import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import SkeletonBox from '../skeleton-box/skeleton-box.vue';

@Component({
  name: 'bpc-grid-mock',
  components: {
    'bpc-skeleton-box': SkeletonBox,
  },
})
export default class GridMock extends Vue {
  @Prop({ type: Number, default: 12 }) readonly nItems: number;
  @Prop({ type: String, default: '250px' }) readonly cardHeight: string;
  @Prop({ type: String, default: '100%' }) readonly cardWidth: string;
}
